import Resize from 'vuetify/lib/directives/resize';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('affix',_vm._b({directives:[{def: Resize,name:"resize",rawName:"v-resize.quiet",value:(_vm.onResizeDebounced),expression:"onResizeDebounced",modifiers:{"quiet":true}}],ref:"affix",staticClass:"sticky-module"},'affix',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }